export const DESK_OWNER_IDENTITY = 'postmaster@desk';
export const BLIPDESK_ACTIVE = 'Lime.IsActive';
export const SALESFORCE_ACTIVE = 'Salesforce';
export const DEFAULT_PROVIDER = 'DefaultProvider';
import * as styles from './configuration.module.scss';
import { AttendanceFeatures } from 'modules/application/detail/attendance/AttendanceFeatures';
import { blipStoreStateExtensionsName } from 'modules/blipStore';
import { blipStoreStateExtensionsDetail } from 'modules/blipStore';
import { BlipStoreFeatures } from 'modules/blipStore/BlipStoreFeatures';
const CUSTOMER_SERVICE_STATES = {
    'Desk': {
        auth: 'auth.application.detail.attendance.channels.blipdesk',
        trackClick: 'helpdesk-integrations-blipdesk-opened',
    },
    'Salesforce': {
        auth: 'auth.application.detail.attendance.channels.salesforce',
        trackClick: 'helpdesk-integrations-salesforce-opened',
    },
    'Webhook': {
        auth: 'auth.application.detail.attendance.channels.webhook',
        trackClick: 'helpdesk-integrations-webhook-opened',
    },
};
const BLIP_STORE_INDICATED_VIEW_ALL_CLICKED_TRACKING = 'helpdesk-indicated-view-all-clicked';
const BLIP_STORE_INDICATED_EXTENSION_CLICKED_TRACKING = 'helpdesk-indicated-extension-clicked';
const BLIP_STORE_PARAMETER_HELPDESK_JOURNEY = 'HelpdesksCustomerServiceChannels';
export class ConfigurationController {
    static $inject = ['application', 'ConfigurationsService', 'ExternalBlipStoreService', '$state', 'MESSAGINGHUBDOMAIN', 'SegmentService', 'LoadingService', '$location', 'TranslateService'];
    constructor(application, ConfigurationsService, ExternalBlipStoreService, $state, MESSAGINGHUBDOMAIN, SegmentService, LoadingService, $location, TranslateService) {
        'ngInject';
        this.application = application;
        this.ConfigurationsService = ConfigurationsService;
        this.ExternalBlipStoreService = ExternalBlipStoreService;
        this.$state = $state;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
        this.SegmentService = SegmentService;
        this.LoadingService = LoadingService;
        this.$location = $location;
        this.TranslateService = TranslateService;
        this.blipStoreStateExtensionsName = blipStoreStateExtensionsName;
        this.blipStoreStateExtensionsDetail = blipStoreStateExtensionsDetail;
    }
    async $onInit() {
        await this.checkFeatures();
        this.styles = styles;
        this.loadConfiguration();
        this.SegmentService.createBotTrack('helpdesk-integrations-opened', this.application);
    }
    async checkFeatures() {
        this.isDeskSalesforceIntegrationEnabled = await AttendanceFeatures.isDeskSalesforceIntegrationEnabled();
        this.isDeskWebhookIntegrationEnabled = await AttendanceFeatures.isDeskWebhookIntegrationEnabled();
        this.isBlipStoreBannerServicePageEnabled = await BlipStoreFeatures.isBlipStoreBannerServicePageEnabled();
        this.isConfigurationsApplicationsDomainUsageGetEnabled = await AttendanceFeatures.isUseConfigurationsDomainOnAttendanceOperationsGetEnabled();
    }
    async loadConfiguration() {
        this.LoadingService.startLoading();
        try {
            const language = await this.TranslateService.getCurrentLanguage();
            if (this.isBlipStoreBannerServicePageEnabled === true) {
                await this.GetExtensionsByParameter(language);
            }
            const settings = await this.ConfigurationsService.get(`${DESK_OWNER_IDENTITY}.${this.MESSAGINGHUBDOMAIN}`, undefined, this.isConfigurationsApplicationsDomainUsageGetEnabled);
            this.defaultProvider = settings[DEFAULT_PROVIDER];
        }
        catch (e) {
            this.defaultProvider = undefined;
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    goToStateAndTrack(state) {
        const customerServiceState = CUSTOMER_SERVICE_STATES[state];
        if (!customerServiceState) {
            return;
        }
        this.SegmentService.createBotTrack(customerServiceState.trackClick, this.application);
        this.$state.go(customerServiceState.auth);
    }
    onOpenBlipStoreExtensionDetail(extensionId) {
        this.SegmentService.createTrack(BLIP_STORE_INDICATED_EXTENSION_CLICKED_TRACKING, {
            extensionName: extensionId,
        });
        if (this.$location.path() !== '/blip-store') {
            this.$state.go(this.blipStoreStateExtensionsDetail, { id: extensionId });
            window.dispatchEvent(new CustomEvent('mfe-route-change', { detail: '/blip-store' }));
        }
    }
    onOpenBlipStore() {
        this.SegmentService.createTrack(BLIP_STORE_INDICATED_VIEW_ALL_CLICKED_TRACKING);
        if (this.$location.path() !== '/blip-store') {
            this.$state.go(this.blipStoreStateExtensionsName, { collection: 'HighlightEvolveTheBlipDeskExperiencePlugins' });
            window.dispatchEvent(new CustomEvent('mfe-route-change', { detail: '/blip-store' }));
        }
    }
    async GetExtensionsByParameter(language) {
        this.extensions = await this.ExternalBlipStoreService.GetExtensionsByParameter(this.application.tenantId, language, BLIP_STORE_PARAMETER_HELPDESK_JOURNEY);
    }
}
ConfigurationController.$inject = ['application', 'ConfigurationsService', 'ExternalBlipStoreService', '$state', 'MESSAGINGHUBDOMAIN', 'SegmentService', 'LoadingService', '$location', 'TranslateService'];
